import { render } from "./SettingsNavigation.vue?vue&type=template&id=9399ef68&scoped=true"
import script from "./SettingsNavigation.vue?vue&type=script&lang=js"
export * from "./SettingsNavigation.vue?vue&type=script&lang=js"

import "./SettingsNavigation.vue?vue&type=style&index=0&id=9399ef68&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9399ef68"]])

export default __exports__